// English language pack
export default {
    // Common
    siteTitle: 'AI Management System',

    // Language selection
    language: 'Language',
    switchToEnglish: 'Switch to English',
    switchToChinese: 'Switch to Chinese',
    switchToVietnamese: 'Switch to Vietnamese',

    // Auth redirect
    authRedirect: {
        verifying: 'Verifying login information...',
        processing: 'Processing login request...',
        invalidToken: 'No valid login information obtained',
        verificationFailed: 'Login verification failed',
        loginSuccess: 'Login successful',
        getUserInfoFailed: 'Failed to get user information',
    },

    // Sidebar
    dashboard: 'Dashboard',
    reports: 'Report Management',
    templates: 'Report Templates',
    svgmaker: 'Text to PPT',
    settings: 'System Settings',
    onelineReport: 'Planning Mode',
    intelligenceQuery: 'Intelligence Query',
    logout: 'Logout',

    // User menu
    profile: 'Profile',
    accountSettings: 'Account Settings',

    // Breadcrumb
    home: 'Home',

    // Dashboard page
    welcomeBack: 'Welcome Back',
    totalReports: 'Total Reports',
    newReportsThisMonth: 'New Reports This Month',
    reportTemplates: 'Report Templates',
    templateVersions: 'Total Template Versions',
    comparedToLastMonth: 'Compared to Last Month',
    recentActivity: 'Recent Activity',
    viewAll: 'View All',
    reportsOverTime: 'Report Trends',
    completedReports: 'Completed Reports',
    reportsInProgress: 'Reports in Progress',
    myRecentReports: 'My Reports',
    createNewReport: 'Create New Report',
    monthly: 'Monthly',
    quarterly: 'Quarterly',
    yearly: 'Yearly',
    createdNewReport: 'Created new report',
    updatedReport: 'Updated report',
    createdNewTemplate: 'Created new template',

    // Status labels
    draft: 'Draft',
    inProgress: 'In Progress',
    completed: 'Completed',
    review: 'Under Review',
    archived: 'Archived',

    // Template management page
    templateManagement: 'Template Management',
    allTemplates: 'All Templates',
    myTemplates: 'My Templates',
    sharedTemplates: 'Shared Templates',
    createTemplate: 'Create Template',
    searchTemplates: 'Search templates...',
    templateName: 'Template Name',
    templateDesc: 'Template Description',
    category: 'Category',
    creator: 'Creator',
    createDate: 'Create Date',
    usageCount: 'Usage Count',
    version: 'Version',
    actions: 'Actions',
    editTemplate: 'Edit Template',
    duplicateTemplate: 'Duplicate Template',
    deleteTemplate: 'Delete Template',
    shareTemplate: 'Share Template',
    templateCategories: 'Template Categories',
    recentlyUsed: 'Recently Used',
    popular: 'Popular Templates',
    newest: 'Newest Templates',

    // Report management page
    reportManagement: 'Report Management',
    allReports: 'All Reports',
    myReports: 'My Reports',
    sharedWithMe: 'Shared with Me',
    archivedReports: 'Archived Reports',
    searchReports: 'Search reports...',
    filterByStatus: 'Filter by Status',
    filterByDate: 'Filter by Date',
    filterByTemplate: 'Filter by Template',
    sortBy: 'Sort by',
    oldest: 'Oldest',
    lastUpdated: 'Last Updated',
    reportName: 'Report Name',
    template: 'Template',
    createdDate: 'Created Date',
    updatedDate: 'Updated Date',
    status: 'Status',
    action: 'Action',
    batchActions: 'Batch Actions',
    export: 'Export',
    archive: 'Archive',
    delete: 'Delete',
    batchDelete: 'Batch Delete',
    itemsPerPage: 'Items per page',
    prev: 'Previous',
    next: 'Next',
    goToPage: 'Go to page',

    // Report details
    reportDetail: 'Report Details',
    edit: 'Edit',
    view: 'View',
    reportInfo: 'Report Information',
    basicInfo: 'Basic Information',
    reportContent: 'Report Content',
    addQuestion: 'Add Question',
    editQuestion: 'Edit Question',
    deleteQuestion: 'Delete Question',
    addAnswer: 'Add Answer',
    saveChanges: 'Save Changes',
    cancel: 'Cancel',
    questionCategories: 'Question Categories',
    allCategories: 'All Categories',
    searchQuestions: 'Search questions...',
    questionCount: 'Question Count',
    answerRate: 'Answer Rate',
    compare: 'Compare',
    print: 'Print',
    share: 'Share',
    comments: 'Comments',
    timeline: 'Timeline',
    activity: 'Activity',

    // Create report page
    createNewReportLong: 'Create New Investigation Report',
    createReportDesc: 'Please select a report template and fill in basic information to create a new investigation report',
    selectTemplate: 'Select Template',
    selectPlanType: 'Select Plan Type',
    confirmCreate: 'Confirm Creation',
    searchTemplate: 'Search template...',
    nextSelectPlanType: 'Next: Select Plan Type',
    prevSelectTemplate: 'Previous: Select Template',
    reportTopicContent: 'Report Topic and Content',
    nextConfirmCreate: 'Next: Confirm Creation',
    prevSelectPlanType: 'Previous: Select Plan Type',
    confirmReportInfo: 'Confirm Report Information',
    selectedTemplate: 'Selected Template',
    confirmCreateReport: 'Confirm Create Report',
    notes: 'Notes',
    note1: 'After creating the report, you can edit and save the report content at any time',
    note2: 'The system will automatically save your edit history and version history',
    note3: 'The report status is "Draft" by default after creation, and can be submitted for review when completed',
    plans: 'plans',
    categories: 'categories',
    questions: 'questions',
    includedCategories: 'Included Categories',
    alreadyCreated: 'Already Created',
    createdReports: 'Reports',
    madeBy: 'Made by',
    system: 'System',
    pleaseSelectValidTemplate: 'Please select a valid template first',
    pleaseEnter: 'Please enter',
    creating: 'Creating...',

    // Time related
    today: 'Today',
    yesterday: 'Yesterday',
    daysAgo: '{n} days ago',
    weeksAgo: '{n} weeks ago',
    unknownDate: 'Unknown date',

    // New key values
    fullscreen: 'Fullscreen',
    confirmLogout: 'Are you sure you want to log out?',
    tip: 'Tip',
    confirm: 'Confirm',
    cancel: 'Cancel',

    // Template list module
    templatesList: {
        pageTitle: 'Template Management',
        pageSubtitle: 'Manage and organize your report templates',
        createTemplate: 'Create Template',
        categoryManagement: 'Category Management',
        templateType: 'Template Type',
        totalTemplates: 'Total Templates',
        templateName: 'Template Name',
        templateDesc: 'Template Description',
        allTemplates: 'All Templates',
        categories: 'Categories',
        search: 'Search',
        searchCategories: 'Search Categories',
        fieldName: 'Field Name',
        type: 'Type',
        publishState: 'Publish Status',
        publish: 'Published',
        unpublish: 'Unpublished',
        goPublish: 'Publish',
        cancelPublish: 'Cancel Publish',
        creator: 'Creator',
        createTime: 'Create Time',
        operations: 'Operations',
        view: 'View',
        noData: 'No Data',
        otherType: 'Other Type',
        dragSortSuccess: 'Drag sort successful, click save button to save changes',
        confirmDelete: 'This operation will permanently delete this item, continue?',
        tip: 'Tip',
        confirm: 'Confirm',
        cancel: 'Cancel',
        deleteSuccess: 'Delete successful',
        deleteCancelled: 'Delete cancelled',
        nameRequired: 'Name cannot be empty',
        saveSuccess: 'Save successful',
        saveFailed: 'Save failed',
        createSuccess: 'Create successful',
        createFailed: 'Create failed',
        pleaseEnter: 'Please enter',
        saveChanges: 'Save Changes',
        editNote: 'Edit Note',
        pleaseEnterEditNote: 'Please enter edit note',
        getTemplateListFailed: 'Failed to get template list',
        unsavedChangesTip: 'You have edited the template, exiting now will discard current edits. It is recommended to save before exiting',
        // Template detail drawer
        templateDetail: 'Template Details',
        editTemplateInfo: 'Edit Template',
        copyTemplateInfo: 'Copy as New Template',
        confirmCopyTemplate: 'The copied new template will belong to you and will not affect existing templates, continue?',
        description: 'Description',
        noDescription: 'No description',
        researchContext: 'Research Context Fields',
        noContextFields: 'No research context fields',
        reportStructure: 'Report Structure',
        addChapter: 'Add Chapter',
        // Node edit drawer
        add: 'Add',
        edit: 'Edit',
        parentChapter: 'Parent Chapter',
        chapterName: 'Chapter Name',
        subChapterName: 'Subchapter Name',
        subChapterQuestion: 'Subchapter Question',
        chapterPrompt: 'Chapter Prompt',
        subChapterPrompt: 'Subchapter Prompt',
        // Category management drawer
        categoryManager: 'Category Management',
        addCategory: 'Add Category',
        editCategory: 'Edit Category',
        categoryName: 'Category Name',
        categoryDesc: 'Category Description',
        categoryAdmin: 'Administrators',
        categoryViewer: 'Viewers',
        addAdmin: 'Add Administrator',
        addViewer: 'Add Viewer',
        selectAdmin: 'Select Administrator',
        selectViewer: 'Select Viewer',
        sortOrder: 'Sort Order',
        categoryCount: 'Template Count',
        categoryActions: 'Actions',
        categoryDeleteTip: 'Cannot delete category with templates',
        categorySystemTip: 'System built-in categories cannot be deleted',
        categoryDeleteConfirm: 'Are you sure you want to delete this category?',
        categoryDeleteSuccess: 'Category deleted successfully',
        categoryDeleteFailed: 'Failed to delete category',
        categorySaveSuccess: 'Category saved successfully',
        categorySaveFailed: 'Failed to save category',
        categoryCreateSuccess: 'Category created successfully',
        categoryOrderUpdateSuccess: 'Category order updated',
        categoryOrderUpdateFailed: 'Failed to update category order',
        dragSortTip: 'You can use this to adjust category order',
        deleteTip: 'Only templates with count 0 can be deleted',
        // New template form
        newTemplate: 'New Template',
        templateTitle: 'Template Title',
        templateDesc: 'Template Description',
        researchContextFields: 'Research Context Fields',
        addField: 'Add Field',
        prompt: 'Prompt',
        titleRequired: 'Template name cannot be empty',
        typeRequired: 'Please select template category',
        descRequired: 'Template description cannot be empty',
        creatorRequired: 'Creator cannot be empty',
        // Permission related
        permission: 'Permission',
        private: 'Personal Use Only',
        public: 'Public within Category',
        // Status tips
        loading: 'Loading...',
        operationSuccess: 'Operation successful',
        operationFailed: 'Operation failed',
        getUserPermissionFailed: 'Failed to get user permissions',
        selectCreateMethod: 'Select Creation Method',
        importQuestionList: 'Import Question List',
        importQuestionListDesc: 'Import question list, AI will organize chapters to create template',
        aiGenerateOutline: 'AI Generate Outline',
        aiGenerateOutlineDesc: 'Use AI to refine report template through dialogue',
        manualCreate: 'Manual Creation',
        manualCreateDesc: 'Enter template basic information, create structured report',
        importQuestionListTitle: 'Import Question List',
        questionListPlaceholder: `Please enter question list, separate each question with a line break. For example:
Target development indications in Chinese patients, number of diagnosable patients and number of patients seeking treatment
Estimated API and formulation production costs, estimated Chinese medical insurance pricing
Estimated sales of competing products with same target and indication in China, and estimated achievable sales in China
Whether there are situations of low cooperation possibility, high clinical development risk, high cooperation cost, high registration risk, or high patent risk`,
        confirmRestoreVersion: 'Are you sure to restore to version {version}?',
        versionHistory: 'Version History',
        currentVersion: 'Current Version',
        restoreToThisVersion: 'Restore to this version',
        modifiedBy: 'Modified by',
        versionRestoreSuccess: 'Successfully restored to version {version}',
        delete: 'Delete',
        confirmDelete: 'Confirm deletion?',
        deleteFailed: 'Delete failed',
        noVersionHistory: 'No version history',
        getTemplateTypeFailed: 'Failed to get template types',
        versionDetail: 'Version Details',
        noVersionDetail: 'No version details',
        changeTemplateStateFailed: 'Failed to change template status',
        versionCount: 'Total {count} versions',
        answerType: 'Answer Type',
        generalAi: 'General AI',
        structuredData: 'Structured Data',
        pleaseSelect: 'Please select',
        searchMethod: 'Search Method',
        networkSearch: 'Network Search',
        aiSearch: 'Local Search',
        networkSearchTip: 'Network search will search internet information\nLocal search only uses local knowledge base or file content',
        presetDatabase: 'Preset Knowledge Base',
        clickToSelect: 'Click to select',
        selectPermission: 'Please select permission',
        promptRequired: 'Prompt cannot be empty',
        selectKnowledgeBase: 'Select Knowledge Base',
        deepSearch: 'Planning Mode',
        ragSearch: 'RAG Enhanced Retrieval',
        directSearch: 'Direct Retrieval',
        ragSearchTip: 'Suitable for large file data scenarios, after enhanced retrieval by large models, only content related to the question is extracted for AI',
        directSearchTip: 'Only suitable for small file data, the entire file content is extracted for AI',
        aiType: 'AI Model',
    },
    svgMaker: {
        pageTitle: 'SVG Chart Generator',
        pageSubtitle: 'Use AI technology to convert your text descriptions into beautiful SVG charts',
        createButton: 'Create New Chart',
        historyTitle: 'History',
        recordCount: '{count} records in total',
        emptyState: 'No history records',
        generatingStatus: 'Generating',
        viewDetails: 'View Details',
        createDialogTitle: 'Create SVG Chart',
        dialogHeader: 'Create New Chart',
        dialogSubtitle: 'Please enter the description of the chart you want to generate',
        inputDescription: 'Please describe in detail the chart you want, including type, style, data, etc.',
        inputPlaceholder: 'For example: Generate a bar chart showing quarterly sales data for 2023, using a blue theme',
        demandsToggle: 'Advanced Settings',
        demandsCustomTag: 'Custom',
        demandsDescription: 'You can add more detailed generation requirements here',
        demandsPlaceholder: 'For example: Use gradient colors, add animation effects, adjust font size, etc.',
        analysisStep: 'Analyzing Requirements',
        extractionStep: 'Extracting Key Information',
        structureStep: 'Building Chart Structure',
        renderingStep: 'Rendering SVG',
        generatingTitle: 'Generating Chart...',
        generationSuccess: 'Chart Generated Successfully',
        resultTitlePlaceholder: 'Please enter chart title',
        regenerateButton: 'Regenerate',
        downloadButton: 'Download SVG',
        completeButton: 'Complete',
        cancel: 'Cancel',
        generateImage: 'Generate Chart',
        preparing: 'Preparing...',
        generating: 'Generating...',
        regenerate: 'Regenerate',
        complete: 'Complete',
        tip: 'Tip',
        confirm: 'Confirm',
        editButton: 'Edit',
        error: {
            minLength: 'To ensure image output quality, please enter at least 20 characters',
            createTask: 'Failed to create task',
            fetchTasks: 'Failed to get image task list',
            generationFailed: 'Image generation failed: {message}',
            generationFailedPrefix: 'Generation Failed - ',
            saveFailed: 'Save failed, please try again'
        },
        unnamedChart: 'Unnamed Chart',
        currentUser: 'Current User',
        imageSaved: 'Image Saved',
        generatingChart: 'Generating Chart...',
        unknownUser: 'Unknown User',
        message: {
            enterEditMode: 'Entered edit mode',
            preparingEditor: 'Preparing editor...',
            editorUnavailable: 'Failed to get SVG content, edit function unavailable',
            svgContentUnavailable: 'Cannot get SVG content, edit function unavailable',
            exitEditMode: 'Exited edit mode',
            saveSuccess: 'Save successful',
            svgDownloadSuccess: 'SVG download successful',
            svgEncodingFailed: 'SVG encoding failed, cannot download',
            preparingDownload: 'Preparing download...',
            svgFetchFailed: 'Failed to get SVG',
            svgContentFetchFailed: 'Failed to get SVG content, cannot download'
        }
    },
    reportsList: {
        pageTitle: 'Report Management',
        pageSubtitle: 'Manage all your analysis reports',
        createNewReport: 'Create New Report',
        reportType: 'Report Type',
        reportStatus: 'Report Status',
        reportSource: 'Report Source',
        searchPlaceholder: 'Search report title or content',
        totalReports: 'Total Reports',
        inProgress: 'In Progress',
        completed: 'Completed',
        view: 'View',
        creator: 'Creator',
        createTime: 'Create Time',
        operations: 'Operations',
        noData: 'No matching reports found',
        noDataTip: 'Please try adjusting filter conditions or search keywords',
        createOptions: {
            title: 'Select Creation Method',
            deepSearch: {
                title: 'Create Instantly with One Sentence',
                desc: 'Just input one sentence, intelligent search materials, generate high-quality professional report'
            },
            ai: {
                title: 'Create After Generating Report Outline',
                desc: 'Use AI to refine report outline through dialogue, then generate complete report content'
            },
            template: {
                title: 'Create from Existing Template',
                desc: 'Select industry professional template, quickly create structured report'
            }
        },
        status: {
            notStarted: 'Not Started',
            inProgress: 'In Progress',
            completed: 'Completed',
            failed: 'Failed',
            unknown: 'Unknown'
        },
        source: {
            normal: 'Normal Report',
            scheduled: 'Scheduled Report',
            system: 'System Report'
        },
        reportTitle: 'Report Title',
        newTag: 'New',
        defaultType: 'AI Report'
    },
    reportDetailModule: {
        loadingText: "Loading report details",
        confirmText: "If you find this reply helpful, please click the confirm button, and I will update this section with the above reply.\n\n <Update to this section>",
        download: "Download",
        downloading: "Downloading",
        saveToKnowledge: "Save to Knowledge Base",
        reportType: "Report Type",
        template: "Template",
        creator: "Creator",
        createTime: "Create Time",
        reportId: "Report ID",
        aiModel: "AI Model",
        temperature: "Temperature",
        researchBackground: "Research Background",
        reportSections: "Report Sections",
        aiSuggestions: "AI Revision",
        aiFeedbackAssistant: "AI Feedback Assistant",
        you: "You",
        from: "From",
        generating: "Generating",
        confirmGenerate: "Confirm Generate",
        inputPlaceholder: "Please enter content to communicate with AI",
        status: {
            notStarted: "Not Started",
            inProgress: "In Progress",
            completed: "Completed",
            failed: "Failed",
            unknown: "Unknown"
        },
        error: {
            fetchFailed: "Failed to get report details",
            fetchAiModelsFailed: "Failed to get AI models",
            downloadLinkInvalid: "Download link invalid",
            updateFailed: "Update failed",
            saveToKnowledgeFailed: "Failed to save to knowledge base",
            fetchChatMessagesFailed: "Failed to get chat messages",
            startChatFailed: "Failed to start chat session",
            generationFailed: "Chapter generation failed",
            errorCount: "Currently {count} chapters have failed to generate",
            retryFailed: "Retry task failed"
        },
        success: {
            updateSuccess: "Update successful",
            saveToKnowledgeSuccess: "Successfully saved to knowledge base",
            retrySuccess: "Retry task started"
        },
        aiAssistant: "AI Assistant",
        welcomeMessage: "Hello! I'm the AI feedback assistant, I can help you analyze and improve the [{section}] content in this report. How can I assist you?",
        thinking: "Thinking",
        nextChapter: "Next Chapter",
        clickToContinue: "Click to continue reading",
        lastChapter: "This is the last chapter",
        cancel: "Cancel",
        save: "Save",
        edit: "Edit",
        unknownModel: "Unknown Model",
        confirmEditDiscard: "You have content being edited, discard previous edits?",
        prompt: "Prompt",
        discard: "Discard",
                share: 'Share',
        shareSuccess: 'Share link copied to clipboard',
        shareFailed: 'Failed to copy share link',
        versionHistory: 'Version History',
        retry: 'Retry',
        retrying: 'Retrying',
      },
      versionList: {
        title: 'Version Compare',
        baseVersion: 'Base Version',
        selectVersionToCompare: 'Select version to compare',
        compare: 'Compare',
        clearCompareVersion: 'Clear compare version',
        selectVersion: 'Select version',
        latestVersion: 'Latest Version',
        version: 'Version',
        reviser: 'Reviser',
      },
    createReport: {
        steps: ['Select Report Category', 'Select Report Template', 'Fill Report Content', 'Confirm Report Information'],
        sectionTitle: 'Select Report Category',
        sectionDesc: 'Please select the type of report you need to create',
        typeBadge: 'templates',
        footerStat: 'Created',
        footerStat2: 'Reports',
        subsectionTitle: 'Select Template',
        subsectionDesc: 'Selected category:',
        fillContentTitle: 'Fill Report Content',
        fillContentDesc: 'Selected template:',
        templateMeta: 'and',
        templateMeta2: 'analysis modules',
        moreSettings: 'More Settings',
        temperatureHint: 'Higher temperature makes AI-generated content more creative, lower temperature makes results more deterministic and predictable',
        aiModelHint: 'Different AI models have their own characteristics in creativity, speed, and efficiency',
        confirmTitle: 'Confirm Report Information',
        confirmDesc: 'Please confirm the following information before creating the report',
        confirmSection1: 'Report Type',
        confirmSection2: 'Report Content',
        confirmSection3: 'Report Analysis Content',
        reportAnalysisTitle: 'Report Analysis Content',
        associatedKnowledge: 'Associated Knowledge',
        srcType: {
            knowledgeBase: 'General AI',
            deepSearch: 'Planning Mode',
            mcp: 'MCP',
            custom: 'Structured Data'
        },
        confirmSection4: 'AI Generation Settings',
        confirmLabel1: 'Category:',
        confirmLabel2: 'Template:',
        confirmLabel3: 'Description:',
        confirmLabel4: 'AI Model:',
        confirmLabel5: 'Temperature:',
        noticeTitle: 'Notes',
        notice1: 'After creating the report, you can edit and save report content at any time',
        notice2: 'The system will automatically save your edit history and version history',
        notice3: 'Report creation takes time, default status is "In Progress", please wait patiently for completion',
        prevStep: 'Previous',
        nextStep: 'Next',
        createReport: 'Confirm Create Report',
        creating: 'Creating...',
        error1: 'Failed to get template types',
        error2: 'Failed to get AI models',
        error3: 'Failed to get template',
        error4: 'Please complete all report content before continuing',
        success: 'Report created successfully!',
        error5: 'Failed to create report, please try again',
        temperature: 'Temperature',
        aiModel: 'AI Model',
        selectAiModel: 'Please select AI model',
        opportunityOverview: 'Opportunity Overview',
        opportunityOverviewRequired: 'Please enter opportunity overview',
        opportunityOverviewPlaceholder: 'You can enter known information or related notes for this report, or fill in "none" if not needed',
        unknownModel: 'Unknown model',
        fieldRequired: 'Please enter {field}',
        fieldPlaceholder: 'Please enter {field}'
        ,
        // Template analysis area additions
        analysisQuestions: '{count} analysis questions',
        associateKnowledgeBtn: 'Associate Knowledge',
        notSupported: 'Not Supported',
        selectKnowledgeBase: 'Select Knowledge Base',
        myCreatedTag: 'Mine',
        noNeedToFill: 'No fields required',
        reportTitle: 'Report Title',
        reportTitlePlaceholder: 'Please enter report title, if not filled will be auto-generated'
    },
    aiChat: {
        chatTitle: 'Create After AI Generates Outline',
        deepSearchTitle: 'AI Instant Creation',
        closeConfirm: 'You have not completed the conversation with AI Intelligence Assistant, are you sure you want to exit?',
        closeReportConfirm: 'You have not generated the report, are you sure you want to exit?',
        inputPlaceholder: 'Please enter content to communicate with AI Intelligence',
        confirmGenerate: 'Confirm Generate',
        thinking: 'Thinking',
        fullscreen: 'Fullscreen',
        exitFullscreen: 'Exit Fullscreen',
        close: 'Close',
        generatingReport: 'Generating AI Report...',
        reportInitialized: 'Report outline successfully initialized',
        goGenerate: 'Go Generate',
        cancel: 'Cancel',
        generating: 'Generating...',
        reportStructure: 'Report Content Structure',
        cancelReport: 'You have cancelled report generation. To continue, please tell me your requirements.',
        error: 'Error occurred',
        sendError: 'Failed to send message, please try again',
        initError: 'Failed to initialize session, please try again',
        getTemplateError: 'Failed to get template data, please try again',
        unknownModel: 'Unknown model',
        you: 'You',
        aiAssistant: 'AI Intelligence Assistant',
        introText: 'Hello! I am the AI Intelligence Assistant, I can help you create reports. Please tell me what report you want to generate, I will work with you to refine the report outline before generating the report.',
        deepSearchIntroText: 'Hello! I am the AI Intelligence Assistant, from answering life questions to professional knowledge, from creative ideas to task planning, I can handle it all! Enter keywords or specific questions to instantly unlock efficient and precise intelligent services.',
        templateIntroText: 'Hello! I am the AI Intelligence Assistant, I can help you create templates. Please tell me what template you want to generate, I will work with you to refine the template outline before generating the template.',
        missingParams: 'Missing report generation parameters',
        reportCreated: 'Report created successfully!',
        reportCreateError: 'Failed to create report, please try again',
        tip: 'Tip',
        confirm: 'Confirm',
        generateTemplate: 'Generate Template',
        selectTemplate: 'Select Template Type',
        templateType: 'Template Type',
        selectTemplateType: 'Please select template type',
        templateCreated: 'Template created successfully',
        templateCreateError: 'Failed to create template',
        getTemplateTypesError: 'Failed to get template types',
        reportTaskCreated: 'Report created successfully',
        userPaused: 'User paused',
        newChatConfirmPC: 'You have not finished your conversation with the AI assistant. Are you sure you want to start a new one?',
        newChatConfirmMobileWithReport: 'Are you sure you want to start a new conversation? The current report can be viewed in the report list.',
        newChatConfirmMobileNoReport: 'You have not finished your conversation with the AI assistant. The current conversation will be lost. Are you sure you want to start a new one?',
        timeFormat: {
            month: '/',
            day: ' ',
            timeSeparator: ':'
        },
        latestChat: 'Already at the Latest Chat',
        chatCompleted: 'Current AI conversation is completed. Click',
        newChat: 'New'
    },
    addGroup: {
        title: 'Set Group',
        commonContacts: 'Common Contacts',
        people: 'People',
        createNewGroup: 'Create New Group',
        cancel: 'Cancel',
        confirm: 'Confirm',
        newGroupTitle: 'Create New Group',
        enterGroupName: 'Please enter group name',
        selectCategory: 'Please select category',
        category: 'Category',
        groupNameRequired: 'Please enter group name',
        addToGroupSuccess: 'Successfully added to group',
        addToGroupFailed: 'Failed to add to group',
        createGroupSuccess: 'Group created successfully',
        createGroupFailed: 'Failed to create group'
    },
    leftArea: {
        searchPlaceholder: 'Search name, pinyin, title...',
        noSearchResults: '-No search results-',
        leaveStatus: '(Left)',
        commonContacts: 'Common Contacts',
        recentContacts: 'Recent Contacts',
        commonContact: 'Common Contact',
        recentContact: 'Recent Contact',
        setGroup: 'Set Group',
        setAsCommonContact: 'Set as Common Contact',
        operationSuccess: 'Operation successful',
        alreadyAdded: 'Already added, please do not repeat',
        limitExceeded: 'Only allowed to add {count} people',
        duplicateSelection: 'Cannot select duplicates',
        noDuplicateSelection: 'Cannot select duplicates',
        people: 'People'
    },
    rightArea: {
        title: 'Right Area',
        searchPlaceholder: 'Search',
        selectAll: 'Select All',
        setGroup: 'Set Group',
        noSelection: 'Please select items first',
        operationSuccess: 'Operation successful',
        setCommonContact: 'Set as Common Contact',
        removeCommonContact: 'Remove from Common Contacts',
        myGroup: 'My Groups',
        maxDeptLimit: 'Only allowed to add {max} departments',
        maxPeopleLimit: 'Only allowed to add {max} people',
        alreadyAdded: 'Already added, please do not repeat',
        alreadyRemoved: 'Already removed, please do not repeat',
        expand: 'Expand',
        retract: 'Collapse',
        rename: 'Rename',
        nextLevel: 'Next Level',
        people: 'People'
    },
    svgEditor: {
        title: 'SVG Editing Mode',
        subtitle: 'Add, edit or delete text elements and drag them to adjust positions',
        addText: 'Add Text',
        removeSelected: 'Remove Selected',
        resetBackground: 'Reset',
        exitEdit: 'Exit Editing',
        save: 'Save',
        undo: 'Undo',
        redo: 'Redo',
        zoomLabel: 'Zoom',
        resetZoom: 'Reset',
        fontSize: 'Font Size',
        fontFamily: 'Font',
        color: 'Color',
        charSpacing: 'Letter Spacing',
        lineHeight: 'Line Height',
        textAlign: 'Align',
        textStyle: 'Text Style',
        bold: 'Bold',
        italic: 'Italic',
        underline: 'Underline',
        strikethrough: 'Strikethrough',
        alignLeft: 'Left',
        alignCenter: 'Center',
        alignRight: 'Right',
        alignSelection: 'Align',
        multiAlignTitle: 'Multi-object Alignment',
        alignLeftEdge: 'Align Left',
        alignHCenter: 'Align Horizontal Center',
        alignRightEdge: 'Align Right',
        alignTopEdge: 'Align Top',
        alignVCenter: 'Align Vertical Center',
        alignBottomEdge: 'Align Bottom',
        enterFullscreen: 'Fullscreen',
        exitFullscreen: 'Exit Fullscreen',
        textPanelTitle: 'Text Properties',
        textPlaceholder: 'Edit the selected text directly here',
        preview: 'Preview',
        download: 'Download',
        previewTitle: 'Canvas Preview',
        previewPlaceholder: 'Generating preview...',
        previewClose: 'Close',
        previewFailed: 'Failed to generate preview',
        downloadSuccess: 'Download started',
        downloadFailed: 'Download failed, please retry',
        defaultText: 'Double click to edit text',
        confirmExit: 'Are you sure you want to discard all changes and revert to the original state?',
        confirm: 'Confirm',
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        successMessage: 'Reverted to the original state',
        saveError: 'Failed to save, please try again',
    },
    database: {
        title: 'Database Management',
        subtitle: 'On this page, you can manage and view database information',
        addRecord: 'Add Record',
        removeRecord: 'Delete Record',
        save: 'Save',
        cancel: 'Cancel',
        confirm: 'Confirm',
        searchPlaceholder: 'Search database...',
        confirmDelete: 'Are you sure you want to delete this record?',
        successMessage: 'Operation successful',
        errorMessage: 'Operation failed, please try again',
        goToPage: 'Go to page',
        page: 'page',
        preview: 'Preview',
        subFolder: 'Sub-level',
        selectedCount: 'Selected',
        item: 'items',
        maxSelect: 'Maximum selection',
        knowledgeBase: 'Knowledge Base',
        created: 'Created',
    },
    onelineReportPage: {
        historyPanel: 'History Sessions',
        newButton: 'New',
        noResult: 'No Results',
        loadMore: 'Scroll to Load More',
        noMoreData: 'No More Data',
        loading: 'Loading',
        userTitle: 'You',
        aiTitle: 'AI Assistant',
        getHistoryFailed: 'Failed to Get History',
        stateMap: {
            0: 'Not Started',
            1: 'In Progress',
            2: 'Completed',
            3: 'Failed'
        },
        emptyHistory: 'No History Records',
        aiAssistant: 'AI Assistant',
        timeFormat: {
            month: '/',
            day: ' ',
            timeSeparator: ':'
        },
        latestChat: 'This is the Latest Conversation',
        chatCompletedPrefix: 'The current intelligent conversation is complete. Click',
        deleteSessionConfirm: 'Are you sure you want to delete session "{name}"?',
        deleteSessionTitle: 'Confirmation',
        deleteSessionConfirmBtn: 'Confirm',
        deleteSessionCancelBtn: 'Cancel',
        deleteSuccess: 'Delete successful',
        deleteFailed: 'Delete failed',
        deleteFailedRetry: 'Delete failed, please try again'
    },
    feedback: {
        button: 'Suggestions? Click to Feedback',
        title: 'Help Us Improve the System! Your Feedback Drives Progress~',
        placeholder: 'Having issues? New requirements? Please provide detailed information, and we will process it quickly~ Please provide as much detail as possible to help us locate the issue faster, such as report titles, features used, etc.',
        cancel: 'Cancel',
        submit: 'Submit Now',
        success: 'Thank you for your feedback!',
        error: 'Failed to submit feedback, please try again later'
    },
    intelligenceQueryPage: {
        inputPlaceholder: 'Please enter your question...',
        generating: 'Generating',
        errorAiService: 'AI service error, please try again later.',
    },
}
